import { Button } from 'antd';
import styled from 'styled-components';

const StyledButton = styled(Button)`
    box-shadow: none;
`;

StyledButton.Group = Button.Group;
export default StyledButton;
